var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.77 32.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.89,12.09a9,9,0,0,1-1,1.45H31.1a12.33,12.33,0,0,0-.82-1.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.29,
    y: 17.43,
    width: 2.4,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.29,
    y: 19.21,
    width: 2.4,
    height: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.97,
    y: 14.07,
    width: 2.78,
    height: 2.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38,
    y: 14.07,
    width: 2.76,
    height: 2.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.59,0H16.18a16.18,16.18,0,1,0,0,32.35H51.59A16.18,16.18,0,1,0,51.59,0ZM23.47,15.6v7.61h-2V15.5h2a9,9,0,0,0-1.12-1.38l1.55-1a8.33,8.33,0,0,1,1.44,1.68l-1.65,1.1A2.88,2.88,0,0,0,23.47,15.6Zm2.82,6.14H24.41V15.92h6.24v5.23H26.29Zm7.86-9.65H32.51a6.67,6.67,0,0,1,.46.85l-1.3.6h2v7.59c0,1-.24,1.46-.93,1.75a8.82,8.82,0,0,1-3,.29,6.43,6.43,0,0,0-.66-1.77c.76,0,1.86,0,2.12,0s.39-.07.39-.32V15.38H25.46V13.54h3.26a13.88,13.88,0,0,0-1.61-1,5,5,0,0,0,.39-.4H26a7.33,7.33,0,0,1,.46.95l-1.78.76a9.33,9.33,0,0,0-.8-1.71h-.24a9.74,9.74,0,0,1-1.33,1.65,14.14,14.14,0,0,0-1.69-1.12,8.16,8.16,0,0,0,2.24-3.18L24.8,10a4.39,4.39,0,0,1-.21.44h2.94v1.64a7.5,7.5,0,0,0,1.34-2.57l1.95.48c0,.14-.1.3-.15.45h3.48ZM48,19.5h-2.2v-.68H43v4.41H40.76V18.82H38v.75H35.89V12h4.87V9.56H43V12h5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangCn);
export default __webpack_public_path__ + "static/media/lang-cn.9bd0d796c8d0e772b90b081adf39313a.svg";
export { ForwardRef as ReactComponent };